import { useTranslation } from '@/i18n/useTranslation';

export function LoadingSkeleton({
  rows = 3,
  height = 20,
  ariaLabel,
}: {
  rows?: number;
  height?: number;
  ariaLabel?: string;
}) {
  const { t } = useTranslation();
  return (
    <div
      className="stack"
      role="status"
      aria-label={ariaLabel ?? t('Loading content')}
      aria-busy="true"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="skeleton"
          style={{ height, width: i === rows - 1 ? '60%' : '100%' }}
        />
      ))}
      <span className="visually-hidden">{ariaLabel ?? t('Loading content')}</span>
    </div>
  );
}

export function KpiSkeletonGrid({ count = 4 }: { count?: number }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid--kpis" role="status" aria-label={t('Loading KPIs')} aria-busy="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="glass-panel kpi-card">
          <div className="skeleton" style={{ height: 12, width: '50%' }} />
          <div className="skeleton" style={{ height: 32, width: '70%', marginTop: 8 }} />
        </div>
      ))}
    </div>
  );
}

export function ChartSkeleton({ height = 280 }: { height?: number }) {
  const { t } = useTranslation();
  return (
    <div
      className="skeleton"
      role="status"
      aria-label={t('Loading chart')}
      aria-busy="true"
      style={{ height, width: '100%' }}
    />
  );
}

export function TableSkeleton({ rows = 6, cols = 5 }: { rows?: number; cols?: number }) {
  const { t } = useTranslation();
  return (
    <div className="table-wrap" role="status" aria-label={t('Loading table')} aria-busy="true">
      <table className="data-table">
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: cols }).map((_, c) => (
                <td key={c}>
                  <div className="skeleton" style={{ height: 14, width: '80%' }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
